/* TIENS-TOI.COM — carrousel, menus et recherche instantanée */
(() => {
  const initTiensToiHome = (root) => {
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const slides = [...root.querySelectorAll('[data-slide]')];
  const dots = [...root.querySelectorAll('[data-dot]')];
  let current = 0;
  let timer;
  const delay = Math.max(3000, Number(root.dataset.delay) || 6000);
  const show = (index) => {
    if (!slides.length) return;
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === current);
      slide.setAttribute('aria-hidden', String(i !== current));
    });
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
  };
  const play = () => { clearInterval(timer); if (slides.length > 1) timer = setInterval(() => show(current + 1), delay); };
  root.querySelector('[data-prev]')?.addEventListener('click', () => { show(current - 1); play(); });
  root.querySelector('[data-next]')?.addEventListener('click', () => { show(current + 1); play(); });
  dots.forEach(dot => dot.addEventListener('click', () => { show(Number(dot.dataset.dot)); play(); }));
  const carousel = root.querySelector('[data-carousel]');
  carousel?.addEventListener('mouseenter', () => clearInterval(timer));
  carousel?.addEventListener('mouseleave', play);
  let touchStartX = null;
  carousel?.addEventListener('touchstart', event => { touchStartX = event.touches[0]?.clientX ?? null; }, { passive: true });
  carousel?.addEventListener('touchend', event => {
    if (touchStartX === null) return;
    const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
    touchStartX = null;
    if (Math.abs(distance) < 45) return;
    show(current + (distance < 0 ? 1 : -1));
    play();
  }, { passive: true });
  play();

  const mobileButton = root.querySelector('[data-mobile-toggle]');
  const mobileMenu = root.querySelector('[data-mobile-menu]');
  mobileButton?.addEventListener('click', () => {
    const opening = mobileMenu.hasAttribute('hidden');
    mobileMenu.toggleAttribute('hidden', !opening);
    mobileButton.setAttribute('aria-expanded', String(opening));
  });

  const overlay = root.querySelector('[data-search-overlay]');
  const input = root.querySelector('[data-search-input]');
  const results = root.querySelector('[data-search-results]');
  const openSearch = () => { overlay.hidden = false; document.body.classList.add('tt-search-is-open'); setTimeout(() => input.focus(), 40); };
  const closeSearch = () => { overlay.hidden = true; document.body.classList.remove('tt-search-is-open'); };
  root.querySelectorAll('[data-search-open]').forEach(button => button.addEventListener('click', openSearch));
  root.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', closeSearch));
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !overlay.hidden) closeSearch(); });

  let searchTimer;
  const escapeHtml = value => String(value || '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-CA', { style: 'currency', currency: root.dataset.currency || 'CAD' }).format(Number(cents || 0) / 100);
  input?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const query = input.value.trim();
    if (query.length < 2) { results.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      results.innerHTML = '<p class="tt-empty">Recherche en cours…</p>';
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=8&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Recherche indisponible');
        const groups = (await response.json()).resources.results;
        const items = [
          ...(groups.products || []).map(item => ({ ...item, kind: 'Produit', image: item.image, meta: money(item.price) })),
          ...(groups.collections || []).map(item => ({ ...item, kind: 'Collection', image: item.image, meta: 'Voir la collection' })),
          ...(groups.pages || []).map(item => ({ ...item, kind: 'Page', image: null, meta: 'Découvrir' }))
        ];
        results.innerHTML = items.length ? items.map(item => `<a class="tt-result" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : '<span></span>'}<span><small>${escapeHtml(item.kind)}</small><strong>${escapeHtml(item.title)}</strong><em>${escapeHtml(item.meta)}</em></span></a>`).join('') : `<p class="tt-empty">Aucun résultat pour « ${escapeHtml(query)} ». Appuie sur Entrée pour chercher partout.</p>`;
      } catch (error) {
        results.innerHTML = '<p class="tt-empty">Appuie sur Entrée pour afficher tous les résultats.</p>';
      }
    }, 220);
  });
  };

  const initAll = (scope = document) => {
    if (scope.matches && scope.matches('[data-tt-home]')) initTiensToiHome(scope);
    scope.querySelectorAll?.('[data-tt-home]').forEach(initTiensToiHome);
  };

  initAll();
  if (!window.__tiensToiSectionListener) {
    window.__tiensToiSectionListener = true;
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  }
})();
